<script>

</script>

<div class="loading">Loading...</div>

<style>
  .loading {
    grid-column: 1 / 7;
    padding: 16px;
    text-align: center;
  }
</style>